module.exports = __webpack_public_path__ + "img/TheVeryLastPizzaPoster.12839374.png";